<div>
	<div class="row">
		<my-col-input #GastosConsumo [tabindex]="tabindex + 1"  [mask]="'c2'" [labelName]="'Gastos de consumo (consumo por ración)'"></my-col-input>
		<my-col-input #GastosSanidad [tabindex]="tabindex + 2"  [mask]="'c2'" [labelName]="'Gastos de sanidad'"></my-col-input>
	</div>	
</div>
